export default __webpack_public_path__ + "static/media/dairy-enabled.b52c8b97.webp";